import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-kameny-winnings',
  setup(__props) {

const getCombinationText = (numbers: number[]) => {
    let text = `${numbers[0]}`;
    if (numbers[1]) text += ` nebo ${numbers[1]}`;
    return text;
};

const winningSum = [
    [6, 36, 25000],
    [7, 35, 4400],
    [8, 34, 1250],
    [9, 33, 474],
    [10, 32, 210],
    [11, 31, 105],
    [12, 30, 55],
    [13, 29, 35],
    [14, 28, 22],
    [15, 27, 15],
    [16, 26, 12],
    [17, 25, 9],
    [18, 24, 8],
    [19, 23, 7],
    [20, 22, 6],
    [21, null, 6],
];

const winningCombinations: [string, number][] = [
    ["jedničky", 25000],
    ["dvojky", 25000],
    ["trojky", 25000],
    ["čtyřky", 25000],
    ["pětky", 25000],
    ["šestky", 25000],
    ["šestice", 4400],
    ["pětice", 147],
    ["čtveřice", 12],
    ["2x trojice", 88],
    ["3x dvojice", 14],
    ["1;2;3;4;5;6", 36],
    ["2;4;6", 36],
    ["1;3;5", 36],
    ["1;2;3", 36],
    ["4;5;6", 36],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "pp-lottery-winnings__title" }, "Kombinace (např. 6 nebo 36, 9 nebo 33, apod.)", -1)),
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Tipovaná kombinace")
              ])),
              _: 1,
              __: [0]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Výherní násobek")
              ])),
              _: 1,
              __: [1]
            })
          ]),
          _: 1
        }),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(winningSum, (sum, index) => {
          return _createVNode(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getCombinationText(sum)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("strong", {
                    innerHTML: formatMultiple(sum[2])
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    }),
    _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "pp-lottery-winnings__title" }, "Kombinace (např. šestice, pětice, apod.)", -1)),
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Tipovaná kombinace")
              ])),
              _: 1,
              __: [2]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Výherní násobek")
              ])),
              _: 1,
              __: [3]
            })
          ]),
          _: 1
        }),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(winningCombinations, (combination, index) => {
          return _createVNode(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(combination[0]), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("strong", {
                    innerHTML: formatMultiple(combination[1])
                  }, null, 8, _hoisted_3)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})